import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-freshman-application',
  templateUrl: './freshman-application.component.html',
  styleUrls: ['./freshman-application.component.scss']
})
export class FreshmanApplicationComponent implements OnInit, OnDestroy {
  freshManAppJson: any;
  commonServiceSubscription: Subscription;

  constructor(private _commonService: CommonService) { }

  ngOnInit() {
    this.commonServiceSubscription = this._commonService.getData().subscribe(detailData => {
      if (detailData && detailData['collegeDetailaddmission']) {
         this.freshManAppJson = detailData['collegeDetailaddmission'];
        }
     });
  }

  ngOnDestroy() {
    this.commonServiceSubscription.unsubscribe();
  }

}
